"use client";
import { SignInLink } from "@/app/[locale]/components/navigation/SignInLink";
import { P } from "@/app/[locale]/components/shared/tags/TextElements";
import {
  CHECKOUT_LINK,
  HOME_LINK,
  POST_SIGNUP_REDIRECT_SESSION_STORAGE,
  TERMS_LINK,
} from "@/app/constants";
import { Link, usePathname } from "@/navigation";
import { Suspense } from "react";
import { event as gaEvent } from "@/app/lib/gtag";
import { FreeSignupForm } from "@/app/[locale]/components/shared/FreeSignupForm";

function storeRedirectPath() {
  sessionStorage.setItem(
    POST_SIGNUP_REDIRECT_SESSION_STORAGE,
    window.location.pathname,
  );
}

export function CTACard({ isFreeTier, text }) {
  const pathname = usePathname();

  return (
    <div className="flex bg-gradient-to-tr from-primary from-70% to-info p-4 shadow-lg lg:p-12">
      <div>
        {isFreeTier ? (
          <>
            <h4 className="my-2 text-2xl font-light text-neutral">
              {text.freeLimitReached}
              <br />
              {text.upgradeToPremium}
            </h4>
            <Link
              href={CHECKOUT_LINK}
              className="btn btn-secondary"
              onClick={() => {
                storeRedirectPath();
                gaEvent("Clicked checkout direct upgrade CTA", {
                  event_category: "Checkout Direct Upgrade",
                  event_label: pathname,
                  value: 0.5,
                });
              }}
            >
              {text.upgrade}
            </Link>
            <Link
              href={`${HOME_LINK}#membership`}
              className="btn ml-2"
              onClick={() => {
                gaEvent("Clicked learn more CTA", {
                  event_category: "Checkout Direct Upgrade",
                  event_label: pathname,
                  value: 0.4,
                });
              }}
            >
              {text.learnMore}
            </Link>
          </>
        ) : (
          <>
            <h4 className="my-2 text-2xl font-light text-neutral">
              {text.freeLimitReached}
              <br />
              {text.signupForMore}
            </h4>
            <FreeSignupForm />
            <p className="mt-1 text-xs font-light italic text-base-100">
              {text.termsOfUse_1}{" "}
              <Link className="link" target="_blank" href={TERMS_LINK}>
                {text.termsOfUse_2}
              </Link>
            </p>
          </>
        )}
        <P extraClasses="my-2 text-neutral">
          {text.alreadyMember}{" "}
          <Suspense fallback={<span>Log In</span>}>
            <SignInLink className="btn btn-ghost text-neutral">
              Log In
            </SignInLink>
          </Suspense>
        </P>
      </div>
    </div>
  );
}
